<template>
  <span>
    <div>
      <select v-model="selection" class="mt-1 p-1 rounded-1">
        <option
          v-for="s in params.statuses"
          :key="s.value"
          :value="s.value"
          >{{ s.text }}</option
        >
      </select>
    </div>
  </span>
</template>

<script lang="js">
import Vue from 'vue'

export default Vue.extend({
  data: function () {
    return {
      selection: null,
    }
  },
  mounted() {
    this.selection = this.params.data.scienceOfReadingStatus || 0
  },
  watch: {
    selection(newValue, oldValue) {
      if (newValue != oldValue && oldValue != null) {
        this.params.data.scienceOfReadingStatus = newValue
        this.params.onSelectionChangedCallback(this.params.node, newValue)
      }
    }
  }
})

</script>